var reqwestRequest = require('./reqwestRequest');
module.exports = require('../lib/clientBuilder')(reqwestRequest);



/*****************
 ** WEBPACK FOOTER
 ** ./reqwest/index.js
 ** module id = 1
 ** module chunks = 0
 **/